import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SEO } from "@/components/SEO";
import { COMPARISONS } from "@/data/comparisonsData";
import { buildItemListSchema } from "@/data/advancedSchemas";
import { getIcon } from "@/components/content/iconResolver";

export default function ComparisonsIndexPage() {
  const schema = buildItemListSchema(COMPARISONS, "/comparatifs", "Comparatifs Mediastore Niort");
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Comparatifs", path: "/comparatifs" },
  ];

  return (
    <div className="min-h-screen" data-testid="comparisons-index-page">
      <SEO
        title="10 Comparatifs Objectifs iPhone, Mac, Samsung — Mediastore Niort"
        description="10 comparatifs honnêtes : iPhone reconditionné vs neuf, Mediastore vs Apple Store, écran origine vs compatible. Mediastore Niort vous aide à choisir."
        keywords="comparatif iPhone, comparatif Mac, iPhone vs Samsung, reconditionné vs neuf, Mediastore vs Apple"
        path="/comparatifs"
        schema={schema}
        breadcrumbs={breadcrumbs}
      />

      <section className="bg-gradient-to-br from-blue-50 to-white pt-12 pb-8">
        <div className="container-custom max-w-4xl text-center">
          <Badge className="bg-blue-100 text-blue-700 px-3 py-1 mb-4 hover:bg-blue-100">
            10 comparatifs honnêtes
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Comparatifs d&apos;achat & réparation
          </h1>
          <p className="text-lg text-slate-700">
            10 comparatifs détaillés pour vous aider à choisir : iPhone reconditionné vs neuf,
            Mediastore vs Apple Store, écran origine vs compatible, MacBook Air vs Pro... Tous
            basés sur les données réelles de notre atelier à Niort.
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-5xl">
          <div className="grid md:grid-cols-2 gap-4">
            {COMPARISONS.map((c) => {
              const Icon = getIcon(c.icon);
              return (
                <Link key={c.slug} to={`/comparatifs/${c.slug}`} className="block group" data-testid={`comparison-link-${c.slug}`}>
                  <Card className="h-full hover:shadow-md transition-shadow border-slate-200 group-hover:border-blue-300">
                    <CardContent className="p-5">
                      <div className="flex gap-3 mb-3">
                        <div className="flex-shrink-0 p-2 bg-blue-50 rounded-lg text-blue-600">
                          <Icon className="h-5 w-5" />
                        </div>
                        <Badge className="bg-slate-100 text-slate-600 text-xs ml-auto hover:bg-slate-100">
                          {c.category}
                        </Badge>
                      </div>
                      <h3 className="font-semibold text-slate-900 group-hover:text-blue-700 transition-colors mb-2">
                        {c.title}
                      </h3>
                      <p className="text-sm text-slate-500 line-clamp-3">
                        {c.metaDescription}
                      </p>
                    </CardContent>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
